import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PublicHeader } from "../components/PublicHeader";
import { StatusPanel } from "../components/StatusPanel";
import { Turnstile } from "../components/Turnstile";
import { invokeFunction, isBackendConfigured } from "../lib/supabase";

export function GuardianPage() {
  const { token = "" } = useParams();
  const [name, setName] = useState("");
  const [accepted, setAccepted] = useState(false);
  const [state, setState] = useState<"idle" | "busy" | "done">("idle");
  const [error, setError] = useState("");
  const [turnstileToken, setTurnstileToken] = useState("");

  async function submit() {
    if (!name || !accepted) return setError("Enter your name and accept the guardian agreement.");
    setState("busy");
    setError("");
    try {
      await invokeFunction("submit-guardian-consent", {
        token,
        guardianName: name,
        accepted: true,
        turnstileToken,
      });
      setState("done");
    } catch (submissionError) {
      setError(submissionError instanceof Error ? submissionError.message : "Could not record consent.");
      setState("idle");
    }
  }

  return (
    <div className="public-page">
      <PublicHeader />
      <main id="main-content" className="legal-shell">
        <span className="eyebrow">GUARDIAN REVIEW</span>
        <h1>Approve the application.</h1>
        {state === "done" ? (
          <StatusPanel title="Approval recorded" message="The application can now move to manual review." kind="success" />
        ) : (
          <>
            <p>The applicant cannot access real leads or paid work until guardian, contract, country, and admin checks are complete.</p>
            <label><span>Guardian full name</span><input className="field" value={name} onChange={(event) => setName(event.target.value)} /></label>
            <label className="check-row"><input type="checkbox" checked={accepted} onChange={(event) => setAccepted(event.target.checked)} />I am the legal guardian and accept Guardian Agreement version 1.0.</label>
            {error && <StatusPanel title="Check the form" message={error} kind="error" />}
            {!isBackendConfigured && <StatusPanel title="Backend required" message="Consent cannot be submitted until Supabase is configured." />}
            <Turnstile onToken={setTurnstileToken} />
            <button className="btn primary" disabled={state === "busy" || !isBackendConfigured} onClick={submit}>{state === "busy" ? "SAVING…" : "APPROVE APPLICATION"}</button>
          </>
        )}
        <Link className="btn" to="/legal/guardian">READ GUARDIAN AGREEMENT</Link>
      </main>
    </div>
  );
}
